import React from "react";
import { useTranslation } from "react-i18next";
import { Box, ButtonBase, Typography } from "@mui/material";
import { HugeiconsIcon } from "@hugeicons/react";
import { IncognitoIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Inline } from "components/layout/reusableLayouts";
import { useImpersonation } from "../../contexts/ImpersonationContext";

const ImpersonationBanner: React.FC = () => {
  const { session, endSession, ending } = useImpersonation();
  const { t } = useTranslation();

  if (!session) return null;

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        width: "100%",
        backgroundColor: "var(--color-bg-brand)",
        color: "var(--color-text-on-brand)",
        boxShadow: "var(--shadow-md)",
      }}
    >
      <Inline
        justify="center"
        gap="var(--space-3) var(--space-5)"
        sx={{ padding: "var(--space-4) var(--space-7)" }}
      >
        <HugeiconsIcon icon={IncognitoIcon} size={24} />
        <Typography variant="body1" component="span" color="inherit">
          {t("You are impersonating")}{" "}
          <Box component="strong">{session.target.email}</Box>
          {session.target.companyName ? (
            <>
              {" · "}
              <Box component="strong">{session.target.companyName}</Box>
            </>
          ) : null}
        </Typography>
        <ButtonBase
          onClick={endSession}
          disabled={ending}
          sx={{
            flexShrink: 0,
            padding: "var(--space-3) var(--space-5)",
            borderRadius: "var(--radius-full)",
            backgroundColor: "var(--color-text-on-brand)",
            color: "var(--color-bg-brand)",
            "&:hover": { opacity: 0.9 },
            "&.Mui-disabled": { opacity: 0.5 },
          }}
        >
          <Typography variant="label" color="inherit">
            {ending ? t("Stopping") : t("Stop impersonating")}
          </Typography>
        </ButtonBase>
      </Inline>
    </Box>
  );
};

export default ImpersonationBanner;
